import React, {
  ReactElement,
  useEffect,
  useState,
  useCallback,
  useReducer,
} from 'react';
import { SchemaWithClient } from '../../types/SchemaWithClient';
import { Entity } from '../../types/entities/Entity';
import {
  Button as MUIButton,
  IconButton,
  Stack,
  Table,
  TableContainer,
  Typography,
} from '@mui/material';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import { MoreOptions } from '../Table/assets/MoreOptions';
import { toaster } from '../../services/toaster';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import { SlidingPaneEdit } from '../Page/SlidingPaneEdit';
import Tooltip from '@mui/material/Tooltip';
import AddIcon from '@mui/icons-material/Add';
import api from '../../services/api';
import { SlidingPaneAddNew } from '../Page/SlidingPaneAddNew';
import CloudDoneRoundedIcon from '@mui/icons-material/CloudDoneRounded';
import Fade from '@mui/material/Fade';
import CircularProgress from '@mui/material/CircularProgress';
import { debounce } from 'lodash';

import Paper from '@mui/material/Paper';
import { accommodationReservation } from '../../schema/accommodationReservation';
import { serviceReservationForGroup } from '../../schema/serviceReservationForGroup';
import {LoadingButton} from "@mui/lab";

type Props<T extends Entity> = {
  schema: SchemaWithClient<T>;
};

const reducer = (state: any, action: any) => {
  switch (action.type) {
    case 'SET_INPUT':
      const newCurrent: any = [...state.current];

      return {
        ...state,
        current: newCurrent,
        send: true,
      };
    case 'SET_HISTORY':
      return {
        ...state,
        current: action.payload,
        send: false,
      };
    default:
      return state;
  }
};

export const ServiceReservation = ({
  schema,
  values,
  fullWidth,
}: {
  schema: any;
  values: any;
  fullWidth: boolean;
}): ReactElement => {
  const [openConfirmDialog, setOpenConfirmDialog] = useState<any>(false);
  const [loading, setLoading] = useState<any>(false);
  const [state, dispatch] = useReducer(reducer, {
    current: [],
    send: false,
  });
  const [openedSlidingPane, setOpenedSlidingPane] = useState<any>({});
  const [query, setQuery] = React.useState<'idle' | 'progress' | 'success'>(
    'idle'
  );
  const timerRef = React.useRef<ReturnType<typeof setTimeout>>();

  const [currentAddNewPaneEntity, setCurrentAddNewPaneEntity] = React.useState<
    any
  >({
    schema: serviceReservationForGroup,
    row: {},
  });

  const fetchMainData = useCallback(() => {
    const searchParams = new URLSearchParams({});

    api
      .get(`/groups/${values.id}/service-reservations`, searchParams)
      .then((res: any) => {
        dispatch({
          type: 'SET_HISTORY',
          payload: res,
        });
      });
  }, []);

  useEffect(() => {
    fetchMainData();
  }, []);

  const debouncedChange = useCallback(
    debounce(() => {
      /* if (state.send) {
        onChange(state.current, 'corporates');
      }*/
    }, 500),
    [state]
  );

  useEffect(() => {
    debouncedChange();
  }, [state, debouncedChange]);

  return (
    <>
      <TableContainer component={Paper}>
        <Table aria-label="simple table" size="small" sx={{}}>
          <TableHead
            sx={{
              '& .MuiTableCell-root': {
                color: 'inherit',
                border: 'none',
              },
              '& .MuiTableRow-root .MuiTableCell-root.MuiTableCell-head': {
                border: 'none',
                fontSize: '14px',
                p: '10px',
              },
              background: '#256861',
              color: '#fff',
            }}
          >
            <TableRow
              sx={{
                '& .MuiTableCell-root': {
                  overflowWrap: 'anywhere',
                },
              }}
            >
              <TableCell
                sx={{
                  minWidth: '200px',
                }}
              >
                Activity
              </TableCell>
              <TableCell
                sx={{
                  minWidth: '100px',
                }}
              >
                Service Group
              </TableCell>
              <TableCell
                sx={{
                  minWidth: '100px',
                }}
              >
                Service
              </TableCell>
              <TableCell
                sx={{
                  minWidth: '50px',
                }}
              >
                Status
              </TableCell>
              <TableCell
                sx={{
                  minWidth: '100px',
                }}
              >
                Date
              </TableCell>
              <TableCell
                sx={{
                  minWidth: '75px',
                }}
              >
                Time
              </TableCell>
              <TableCell
                sx={{
                  minWidth: '50px',
                }}
              >
                Size
              </TableCell>
              <TableCell sx={{}}></TableCell>
            </TableRow>
          </TableHead>
          {state.current.map((accommodationItem: any) => {
            return (
              /*<CollapseRow
                row={accommodationItem}
                fullWidth={fullWidth}
                clickOnEdit={(item: any) => {
                  setOpenedSlidingPane({
                    schema: accommodationReservation(),
                    row: item,
                  });
                }}
                clickOnDelete={(item: any) => {
                  setOpenConfirmDialog({
                    row: item,
                    schema: accommodationReservation(),
                  });
                }}
              />*/
              <TableRow
                sx={{
                  textDecoration: accommodationItem?.service_reservation_type_id === 4 ? 'line-through' : ''
                }}
              >
                <TableCell>
                  {accommodationItem?.activity_reservation?.activity?.name}
                </TableCell>

                <TableCell>
                  {accommodationItem?.service_package?.name}
                </TableCell>

                <TableCell>{accommodationItem?.service?.name}</TableCell>
                <TableCell>
                  {accommodationItem?.service_reservation_status?.name}
                </TableCell>
                <TableCell>{accommodationItem?.date}</TableCell>

                <TableCell>{accommodationItem?.time}</TableCell>

                <TableCell>{accommodationItem?.group_size}</TableCell>
                <TableCell>
                  <MoreOptions
                    clickOnEdit={() => {
                      setOpenedSlidingPane({
                        ...openedSlidingPane,
                        ['row']: accommodationItem,
                      });
                    }}
                    clickOnDelete={() => {
                      setOpenConfirmDialog({
                        row: accommodationItem,
                        schema: serviceReservationForGroup,
                      });
                    }}
                  />
                </TableCell>
              </TableRow>
            );
          })}
        </Table>
      </TableContainer>

      <Stack
        direction={'row'}
        alignItems={'center'}
        sx={{
          width: '100%',
        }}
        justifyContent={'space-between'}
      >
        <Stack direction={'row'}>
          <Tooltip
            title={`Add new`}
            slotProps={{
              popper: {
                modifiers: [
                  {
                    name: 'offset',
                    options: {
                      offset: [0, -14],
                    },
                  },
                ],
              },
            }}
          >
            <IconButton
              color={'primary'}
              onClick={() => {
                setCurrentAddNewPaneEntity({
                  row: {
                    id: 'new',
                    group: {
                      id: values?.id,
                      name: values?.name,
                    },
                  },
                  schema: accommodationReservation(),
                });
              }}
            >
              <AddIcon />
            </IconButton>
          </Tooltip>
        </Stack>
        <Stack>
          {query === 'success' ? (
            <Stack direction={'row'} alignItems={'center'}>
              <CloudDoneRoundedIcon color={'disabled'} />
              <Typography variant={'caption'} marginLeft={'5px'} color={'gray'}>
                successfully saved
              </Typography>
            </Stack>
          ) : (
            <Fade
              in={query === 'progress'}
              style={{
                transitionDelay: query === 'progress' ? '800ms' : '0ms',
              }}
              unmountOnExit
            >
              <CircularProgress size={20} />
            </Fade>
          )}
        </Stack>
      </Stack>

      {currentAddNewPaneEntity?.row?.id && (
        <>
          <SlidingPaneAddNew
            schema={currentAddNewPaneEntity?.schema}
            mainSchema={schema}
            id={currentAddNewPaneEntity?.row?.id}
            hasSlidingPane={false}
            onSubmit={(result: any) => {
              fetchMainData();
              setCurrentAddNewPaneEntity({
                schema: schema,
                row: {},
                key: undefined,
              });
              setQuery('progress');
              timerRef.current = setTimeout(() => {
                setQuery('success');
              }, 2000);

              return true;
            }}
            propertiesFromTable={
              currentAddNewPaneEntity?.row ? currentAddNewPaneEntity?.row : {}
            }
            row={
              currentAddNewPaneEntity?.row ? currentAddNewPaneEntity?.row : {}
            }
            onClose={(value) => {
              setCurrentAddNewPaneEntity({
                schema: schema,
                row: {},
                key: undefined,
              });
            }}
          />
        </>
      )}

      <Dialog
        open={openConfirmDialog}
        onClose={() => {
          setOpenConfirmDialog(false);
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {'Are you sure you want to delete it?'}
        </DialogTitle>
        <DialogActions>
          <MUIButton
            onClick={() => {
              setOpenConfirmDialog(false);
            }}
          >
            Cancel
          </MUIButton>
          <LoadingButton
            loading={loading}
            variant={'contained'}
            color={'error'}
            onClick={() => {

              setLoading(true);

              const deletedRow = openConfirmDialog?.row;
              openConfirmDialog?.schema.client
                .delete(deletedRow.id as number, { id: deletedRow.id })
                .then((res: any) => {
                  const tempProperties = [...state.current];

                  const newRows = tempProperties.filter((contact: any) => {
                    return contact?.id !== deletedRow?.id;
                  });

                  dispatch({
                    type: 'SET_HISTORY',
                    payload: newRows,
                  });

                  toaster.show({
                    intent: 'success',
                    message: `Successfully deleted ${schema.name}: ${
                      deletedRow?.name ? deletedRow?.name : deletedRow?.id
                    }`,
                  });
                  setOpenConfirmDialog(false);

                  setQuery('progress');
                  timerRef.current = setTimeout(() => {
                    setQuery('success');
                  }, 2000);
                })
                .catch((e: any) => {
                  toaster.show({
                    icon: 'error',
                    message: `Error: Unable to delete ${schema.name}: ${
                      deletedRow?.name ? deletedRow?.name : deletedRow?.id
                    }`,
                    intent: 'danger',
                  });
                }).finally(()=>{
                  setLoading(false);
              });
            }}
            autoFocus
          >
            Delete
          </LoadingButton>
        </DialogActions>
      </Dialog>

      {openedSlidingPane?.row?.id && (
        <SlidingPaneEdit
          schema={openedSlidingPane?.schema}
          id={openedSlidingPane?.row?.id}
          onSubmit={() => {
            setOpenedSlidingPane({});
            fetchMainData();

            setQuery('progress');
            timerRef.current = setTimeout(() => {
              setQuery('success');
            }, 2000);
          }}
          propertiesFromTable={
            openedSlidingPane?.row ? openedSlidingPane?.row : {}
          }
          onClose={(value) => {
            setOpenedSlidingPane({});
          }}
        />
      )}
    </>
  );
};
